module.exports = __webpack_public_path__ + "img/wrapbg5.0f91c0f8.png";